<div class="table-responsive">
  <table *ngIf="podeAdicionar" class="table table-hover">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">ECG pago por: *</th>
        <th scope="col" *ngIf="deveAdicionarCodigo">Código de validação da avaliação do projeto *</th>
      <tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <span *ngIf="modoEdicao || emInclusao"><a (click)="removerTipo()"><i
                class="fa fa-trash cursor-pointer"></i></a></span>
        </td>
        <td>
          <select class="form-control" id="tipoGarantia" name="tipoGarantia"
            (change)="atribuirTipo($event.target.value)" required [disabled]="!modoEdicao && !emInclusao">
            <option [value]="undefined" [selected]="!identificadorTipoPagamentoEcgTerceiro">(selecione um tipo de
              pagamento)</option>
            <option [value]="tipo.ide"
              [selected]="identificadorTipoPagamentoEcgTerceiro == tipo.ide"
              *ngFor="let tipo of tiposPagamento">
              {{tipo.ide}} - {{tipo.nomeTipoPagamentoEcgTerceiro}}</option>
          </select>

        </td>
        <td *ngIf="deveAdicionarCodigo">
          <input type="text" class="form-control" name="codigoValidacao" id="codigoValidacao"
          [(ngModel)]="operacao.codigoValidadorPagamentoTerceiros" [disabled]="!modoEdicao && !emInclusao">
        </td>
      </tr>
    </tbody>
  </table>
  <a (click)="adicionarGarantia()" *ngIf="modoEdicao || emInclusao"><i class="fa fa-plus-circle cursor-pointer"></i></a>
</div>


<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
